import { render, staticRenderFns } from "./OauthAuthorize.vue?vue&type=template&id=55577994&scoped=true"
import script from "./OauthAuthorize.vue?vue&type=script&lang=js"
export * from "./OauthAuthorize.vue?vue&type=script&lang=js"
import style0 from "./OauthAuthorize.vue?vue&type=style&index=0&id=55577994&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55577994",
  null
  
)

export default component.exports